export default __webpack_public_path__ + "static/media/avatar.822191a9.png";